import { useEffect, useState } from 'react';
import config from '../../common/config';

import './styles/Digest5.less';

const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const [playDesc, setPlayDesc] = useState(false);

  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 300);
    } else {
      setDelayPlay(false);
      setPlayDesc(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <div className={`digest ${delayPlay ? 'ani-play' : ''}`}>
        <div className={`logo-q`}>
          <img src={config.getFullUrl('images/logo-q.svg')} alt="logo quality" />
        </div>
        <div className={`text-block`}>
          <div
            className={`titles ${delayPlay ? 'ani-fade-in' : ''}`}
            onTransitionEnd={() => {
              setPlayDesc(true);
            }}
          >
            <div className="title title-primary">实现品质</div>
            <div className="title title-secondary">代码健壮</div>
          </div>

          <div className={`description ${playDesc ? 'ani-fade-in' : ''}`}>
            <div>
              <span className="bold">开发中：</span>组件Owner机制；同一套代码，规避不同端差异；
            </div>
            <div>
              <span className="bold">运行时：</span>异常捕获、页面兜底，杜绝应用crash或异常白屏；
            </div>
            <div>
              <span className="bold">生产运维：</span>APM监控告警、hotfix修复代码快速发布；
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
